import React from "react";
import { Component } from "react";

import Resume from "views/profile/profile/components/Resume";
import Contact from "views/profile/profile/components/Contact";
import Education from "views/profile/profile/components/Education";
import Experience from "views/profile/profile/components/Experience";
import Miscellaneous from "views/profile/profile/components/Miscellaneous";
import Social from "views/profile/profile/components/Social";
import { connect } from "react-redux";
import {
  getContactAction,
  getEducationAction,
  getEmployeeAction,
  getlanguageAction,
} from "store/userWalkthrough";
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabOpenNo: 1,
    };
  }
  async checkHCSession() {
    if (!this.props.Auth.HCID) {
      alert("please complete basic first");
      return false;
    } else {
      return true;
    }
  }
  async getContactDetails() {
    if (await this.checkHCSession()) {
      await this.props.getContactAction(this.props.Auth.HCID);
      this.setState({ isTabOpenNo: 2 });
    }
  }
  async getEducationDetails() {
    debugger;
    if (await this.checkHCSession()) {
      await this.props.getEducationAction(this.props.Auth.HCID);
      this.setState({ isTabOpenNo: 3 });
    }
  }
  async getEmploymentDetails() {
    if (await this.checkHCSession()) {
      await this.props.getEmployeeAction(this.props.Auth.HCID);
      this.setState({ isTabOpenNo: 4 });
    }
  }
  async getMiscellaneousDetails() {
    if (await this.checkHCSession()) {
      await this.props.getlanguageAction(this.props.Auth.HCID);
      this.setState({ isTabOpenNo: 5 });
    }
  }
  render() {
    return (
      <div class="pt-4 ">
        <ul class="list-reset flex  custom-tabs-r px-4">
          <li
            className={
              this.state.isTabOpenNo == 1
                ? "font-bold text-black  active tab-submenu-active "
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 1 })}
          >
            <p className="tab-submenu px-4 fsize14">Resume</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 2
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.getContactDetails()}
          >
            {" "}
            <p className="tab-submenu px-4 fsize14">Contact</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 3
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.getEducationDetails()}
          >
            {" "}
            <p className="tab-submenu px-4 fsize14">Education</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 4
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.getEmploymentDetails()}
          >
            <p className="tab-submenu px-4 fsize14">Experience</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 5
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.getMiscellaneousDetails()}
          >
            <p className="tab-submenu px-4 fsize14">Miscellaneous</p>
          </li>{" "}
   
          <li
            className={
              this.state.isTabOpenNo == 6
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 6 })}
          >
            <p className="tab-submenu px-4 fsize14">Social</p>
          </li>
        </ul>
        <div className={this.state.isTabOpenNo == 1 ? " active" : "hidden"}>
          <Resume />
        </div>
        {this.state.isTabOpenNo == 3 ? (
          <div className={this.state.isTabOpenNo == 3 ? " active" : "hidden"}>
            <Education />
          </div>
        ) : (
          ""
        )}
        {this.state.isTabOpenNo == 4 ? (
          <div className={this.state.isTabOpenNo == 4 ? " active" : "hidden"}>
            <Experience />
          </div>
        ) : (
          ""
        )}
        {this.state.isTabOpenNo == 5 ? (
        <div className={this.state.isTabOpenNo == 5 ? " active" : "hidden"}>
          <Miscellaneous />
        </div>
         ) : (
          ""
        )}
        {this.state.isTabOpenNo == 2 ? (
          <div className={this.state.isTabOpenNo == 2 ? " active" : "hidden"}>
            <Contact />
          </div>
        ) : (
          ""
        )}
        <div className={this.state.isTabOpenNo == 6 ? " active" : "hidden"}>
          <Social />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getSingleApplicantInfoAction: async (payload) => {await dispatch(getSingleApplicantInfoAction(payload))},
    getContactAction: async (payload) =>
      await dispatch(getContactAction(payload)),
    getEducationAction: async (payload) =>
      await dispatch(getEducationAction(payload)),
    getEmployeeAction: async (payload) =>
      await dispatch(getEmployeeAction(payload)),
    getlanguageAction: async (payload) =>
      await dispatch(getlanguageAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
